import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from "../utilities/colors";
import spacings from "../utilities/spacings";
import ReactGravatar from "react-gravatar";
import moment from "moment";

const CommentWrapper = styled.div`
  display: flex;
  margin-bottom: ${spacings.m};
  
  .avatar {
    border-radius: 100%;
    background: ${colors.lightGrey};
    background-size: cover;
    background-position: center center;
    height: 32px;
    width: 32px;
    margin-right: 10px;
  }
  
  .caption {
    color: ${colors.darkGrey};
    font-size: 12px;
  }
  
  .h4 {
    margin: 0 0 3px;
  }
  
  .comment-meta {
    min-width: 200px;
  }
  
  .comment-bubble {
    background: ${colors.lightGrey};
    border-radius: 16px;
    padding: 20px;
    position: relative;
    &::after {
      position: absolute;
      top: 50%;
      left: -10px;
      margin-top: -10px;
      content: "";
      border-right: 10px solid ${colors.lightGrey};
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
  }
  
  p {
    margin-top: 0;
    font-size: 14px;
    &:last-child {
      margin: 0;
    }
  }
  
  @media (max-width: 850px) {
    display: block;
    
    .comment-bubble {
      &::after {
          position: absolute;
          top: -10px;
          left: 13px;
          content: "";
          border-left: 10px solid transparent;
          border-bottom: 10px solid ${colors.lightGrey};
          border-right: 10px solid transparent;
        }
    }
    
    .comment-meta {
      margin-bottom: 15px;
      margin-left: 5px;
    }
  }
  
  .approve, .reject {
    background: none;
    border: none;
    font-size: 13px;
    margin-right: 5px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  
  .approve {
    color: green;
  }
  
  .reject {
    color: orange;
  }
`;

const Comment = props => {
    return (
        <CommentWrapper>
            <div className={'comment-meta u-flex u-align-items-center'}>
                <div>
                    { props.photo ? <div style={{backgroundImage: 'url(' + props.photo + ')'}} className="avatar">

                    </div> : <ReactGravatar email={props.email ? props.email : 'Anonymous'} className="avatar" /> }
                </div>
                <div>
                    <h4 className={'h4'}>{props.display_name}</h4>
                </div>
            </div>
            <div className={'comment-content u-flex-grow'}>
                <div className={'comment-bubble'}>
                    <p>{props.content}</p>
                </div>
                {props.moderation ? (
                    <div className="actions">
                        <button className={'reject'} onClick={() => { props.removeComment(props.uid)} }>Remove comment</button>
                    </div>
                ) : ''}

            </div>
        </CommentWrapper>
    );
};

Comment.propTypes = {
    user_id: PropTypes.string,
    display_name: PropTypes.string,
    email: PropTypes.string,
    date_added: PropTypes.number,
    content: PropTypes.string,
    approved: PropTypes.bool,
    moderation: PropTypes.bool
};

export default Comment;
